<template>
	<div class="flow-auth-box-container">
		<div v-if="$slots['logo']" class="flow-auth-logo">
			<slot name="logo" />
		</div>
		<div class="flow-auth-box">
			<slot />
		</div>
		<div class="flow-auth-box-footer">
			<slot name="footer" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "AuthContainer"
});
</script>
<style lang="scss">
div.flow-auth-box-container {
	display: flex;
	// width: 100%;
	// height: 100%;
	align-items: center;
	// padding-top: 60px;
	// justify-content: center;
	flex-direction: column;

	> div.flow-auth-box {
		width: 500px;
		min-height: 350px;
		background-color: var(--dashboard-element-light);
		border-radius: 12px;
		transition: transform 1s;
		transform-style: preserve-3d;
		overflow: hidden;

		div.flow-input-wrapper {
			background-color: var(--dashboard-element);
			> input.flow-input-text,
			> textarea.flow-input-text {
				background-color: var(--dashboard-element) !important;

				&:hover,
				&:active,
				&:focus {
					-webkit-box-shadow: 0 0 0 30px var(--dashboard-element) inset !important;
				}

				&:-webkit-autofill {
					-webkit-box-shadow: 0 0 0 30px var(--dashboard-element) inset !important;
				}
			}
		}
	}

	> div.flow-auth-logo {
		margin-bottom: 32px;
		div.icon-container > div.icon svg {
			// height: 108px;
			width: 300px;
		}
	}
	> div.flow-auth-box-footer {
		margin-top: 12px;
		width: 350px;
		text-align: center;
	}
}

@media (max-width: 550px) {
	div.flow-auth-box-container {
		> div.flow-auth-box {
			width: 380px;
		}
	}
}

div.flow-auth-logo-outside {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 60px;
	margin-bottom: 32px;
	div.icon-container > div.icon svg {
		// height: 108px;
		width: 300px;
	}
}
</style>
